<div
  *ngIf="show"
  class="fixed inset-0 z-[9999] flex justify-center items-center bg-black/50 backdrop-blur-sm px-4 animate-fade-in"
  (click)="onOverlayClick()"
>
  <div
    class="relative w-full max-w-md max-h-[90vh] overflow-hidden animate-scale-up"
    (click)="$event.stopPropagation()"
  >
    <div class="bg-white rounded-3xl shadow-2xl flex flex-col overflow-hidden">
      <!-- Decorative Header Background -->
      <div class="relative bg-gradient-to-br from-blue-500 to-purple-600 px-6 py-8">
        <!-- Close Button (only for non-mandatory updates) -->
        <button
          *ngIf="canClose"
          mat-icon-button
          (click)="onCancel()"
          class="absolute top-3 right-3 text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all"
        >
          <mat-icon>close</mat-icon>
        </button>

        <!-- Update Icon -->
        <div class="flex justify-center mb-4">
          <div class="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center animate-bounce-slow">
            <mat-icon class="text-white" style="font-size: 48px; width: 48px; height: 48px;">
              {{ data?.mandatory ? 'priority_high' : 'system_update_alt' }}
            </mat-icon>
          </div>
        </div>

        <!-- Header Title -->
        <h3 class="text-2xl font-bold text-white text-center">
          {{ data?.mandatory ? '⚠️ Required Update' : '🎉 Update Available' }}
        </h3>
        <p class="text-white/90 text-center mt-2 text-sm">
          Version {{ data?.latestVersion }}
        </p>
      </div>

      <!-- Body -->
      <div class="p-6 space-y-4">
        <!-- Update Message -->
        <div class="text-center">
          <p class="text-gray-700 leading-relaxed">
            {{ updateMessage }}
          </p>
        </div>

        <!-- Changelog Section -->
        <div
          *ngIf="data?.changelog"
          class="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-100 rounded-xl p-4 space-y-2"
        >
          <div class="flex items-center gap-2 mb-3">
            <mat-icon class="text-blue-600 text-xl">auto_awesome</mat-icon>
            <strong class="text-gray-800 font-semibold">What's New</strong>
          </div>
          <p class="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
            {{ data.changelog }}
          </p>
        </div>

        <!-- Mandatory Warning Badge -->
        <div
          *ngIf="data?.mandatory"
          class="flex items-center gap-2 bg-red-50 border border-red-200 rounded-xl p-3 animate-pulse-slow"
        >
          <mat-icon class="text-red-600 text-xl">error</mat-icon>
          <p class="text-red-700 text-sm font-medium flex-1">
            This update is required to continue using the app
          </p>
        </div>

        <!-- Optional: Update Size/Features -->
        <div *ngIf="!data?.mandatory" class="flex items-center justify-center gap-6 text-xs text-gray-500">
          <div class="flex items-center gap-1">
            <mat-icon class="text-base">bug_report</mat-icon>
            <span>Bug Fixes</span>
          </div>
          <div class="flex items-center gap-1">
            <mat-icon class="text-base">speed</mat-icon>
            <span>Performance</span>
          </div>
          <div class="flex items-center gap-1">
            <mat-icon class="text-base">security</mat-icon>
            <span>Security</span>
          </div>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="flex gap-3 border-t border-gray-100 px-6 py-4 bg-gray-50">
        <button
          *ngIf="canClose"
          mat-stroked-button
          color="primary"
          (click)="onCancel()"
          class="flex-1 py-3 font-semibold rounded-xl border-2 border-gray-300 text-gray-700 hover:bg-gray-100 transition-all"
        >
          <span class="flex items-center justify-center gap-2">
            <mat-icon>schedule</mat-icon>
            Later
          </span>
        </button>

        <button
          mat-raised-button
          [color]="data?.mandatory ? 'warn' : 'primary'"
          (click)="onUpdate()"
          [class]="canClose ? 'flex-1' : 'w-full'"
          class="py-3 font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02]"
        >
          <span class="flex items-center justify-center gap-2">
            <mat-icon>download</mat-icon>
            {{ data?.mandatory ? 'Update Now' : 'Update' }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>